import React, { useState } from 'react';
import styled from 'styled-components';
import DashboardHeader from '../../components/dashboard/DashboardHeader';
import DashboardFooter from '../../components/dashboard/DashboardFooter';

const SettingsWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const SettingsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
`;

const SettingsTitle = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
`;

const SettingsCard = styled.div`
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
`;

const CardTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 20px;
  border-bottom: 2px solid #ff6b35;
  padding-bottom: 10px;
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, #ff6b35 0%, #e55a2b 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #c3e6cb;
`;

const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
`;

const Description = styled.p`
  color: #666;
  font-size: 0.9rem;
  margin-top: 5px;
  font-style: italic;
`;

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSave = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // Простая заглушка для сохранения
      await new Promise(resolve => setTimeout(resolve, 1000));
      setMessage('Настройки временно недоступны');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setError('Ошибка при сохранении настроек');
      console.error('Error saving settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SettingsWrapper>
      <DashboardHeader />
      <SettingsContainer>
        <SettingsTitle>Настройки системы</SettingsTitle>
        
        {message && <SuccessMessage>{message}</SuccessMessage>}
        {error && <ErrorMessage>{error}</ErrorMessage>}

        <SettingsCard>
          <CardTitle>Настройки системы</CardTitle>
          <Description>
            Настройки системы временно недоступны. Обратитесь к администратору.
          </Description>
        </SettingsCard>

        <SaveButton onClick={handleSave} disabled={loading}>
          {loading ? 'Сохранение...' : 'Сохранить настройки'}
        </SaveButton>
      </SettingsContainer>
      <DashboardFooter />
    </SettingsWrapper>
  );
};

export default Settings;
